window.addEventListener('load', function(event) {
    window.addEventListener("scroll", scrollHandler);
});

var is25ScrollFired = false;
var is50ScrollFired = false;
var is75ScrollFired = false;
var is100ScrollFired = false;

function scrollHandler() {
    var scrollTop = window.scrollY;
    var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPercent = scrollTop / scrollHeight;
    var scrollPercentRounded = Math.round(scrollPercent*100);

    if (!is25ScrollFired && scrollPercentRounded > 25 && scrollPercentRounded < 50) {
        Shopify.analytics.publish("pageScroll", {percent: 25});
        is25ScrollFired = true;
    } 
    else if (!is50ScrollFired && scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        Shopify.analytics.publish("pageScroll", {percent: 50});
        is50ScrollFired = true;
    } 
    else if (!is75ScrollFired && scrollPercentRounded >= 75 && scrollPercentRounded < 100) {
        Shopify.analytics.publish("pageScroll", {percent: 75});
        is75ScrollFired = true;
    } 
    else if (!is100ScrollFired && scrollPercentRounded >= 100) {
        Shopify.analytics.publish("pageScroll", {percent: 100});
        is100ScrollFired = true;
    }
}